export default __webpack_public_path__ + "static/media/graxalta_VES_webdesign2021_headeranimation_responsive_01.aff93a81.mp4";